import { useSelector } from 'react-redux';
import type { AppState } from '@nextgen-web-framework/core';
import OtpInputField from '../otp-input-field/OtpInputField';
import ResendOtpLink from '../resend-otp-link/ResendOtpLink';
import CountdownClock from '../countdown-clock/CountdownClock';
import OtpVerifiedLabel from '../otp-verified-label/OtpVerifiedLabel';
import OtpCheckingLabel from '../otp-checking-label/OtpCheckingLabel';
import OtpInvalidLabel from '../otp-invalid-label/OtpInvalidLabel';
import { VerifyCodeFormProps } from './types/propTypes';
import styles from './VerifyCodeForm.module.scss';

const VerifyCodeForm = ({ sendOtpNotification, autoverify = true }: VerifyCodeFormProps) => {
  const { secondsLeft } = useSelector((state: AppState) => state.commerceIdentity.resendClockData);
  const { isChecking, isVerified, isInvalid } = useSelector((state: AppState) => state.commerceIdentity.otpData);

  return (
    <div className={styles['identity-verify-otp-form']}>
      <div className={styles['layout-container']}>
        <OtpInputField name="otp" autoverify={autoverify} />
        <div className={styles['feedback-section']}>
          <div className="">
            {isVerified && <OtpVerifiedLabel />}
            {isChecking && <OtpCheckingLabel />}
            {isInvalid && <OtpInvalidLabel />}
          </div>
          <div className="resend-section" data-testid="resend-section-test-id">
            {!isVerified && secondsLeft === 0 && <ResendOtpLink onClick={sendOtpNotification} />}
            {!isVerified && secondsLeft > 0 && <CountdownClock />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyCodeForm;
